import { UI } from '@/Components/UI';
import { useForm } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useWakeLock } from '@/hooks';

type CookingModeForm = {
    cookingMode: boolean;
}

export const CookingMode = () => {
    const { t } = useTranslation(['recipes']);

    const form = useForm<CookingModeForm>();
    const wakeLock = useWakeLock();

    useEffect(() => {
        if (form.data.cookingMode) {
            wakeLock.request();
        } else {
            wakeLock.release();
        }
    }, [form.data]);

    return (
        <UI.Form<CookingModeForm>
            form={form}>
            <UI.Form.Toggle
                name={'cookingMode'}
                label={t('cookingMode.title')}
                hint={t('cookingMode.description')}
                required={true}
                groupClassName={'mb-0'} />
        </UI.Form>
    );
};
